import { apiInstance } from 'api/utils';

const platformApi = {
  getHoldings: ({ portfolio }: { portfolio: any }) =>
    apiInstance.request({
      method: 'GET',
      url: `/cases/${portfolio}/holdings/`
    }),
  getProviders: () => {
    return apiInstance.request({
      method: 'GET',
      url: '/firm/providers/'
    });
  },
  setHoldings: ({ portfolio, data }: { portfolio: any; data: any }) =>
    apiInstance.request({
      method: 'POST',
      url: `/cases/${portfolio}/holdings/`,
      data: data
    }),
  updateHolding: ({
    portfolio,
    id,
    data
  }: {
    portfolio: any;
    id: number;
    data: any;
  }) =>
    apiInstance.request({
      method: 'PUT',
      url: `/cases/${portfolio}/holdings/${id}/`,
      data: data
    }),
  deleteHolding: ({ portfolio, id }: { portfolio: any; id: number }) =>
    apiInstance.request({
      method: 'DELETE',
      url: `/cases/${portfolio}/holdings/${id}/`
    })
};

export default {
  ...platformApi
};
